import * as constants from './config/constants.js';
import ResponseHandler from './utils/response-handler.js';
import RequestHandler from './utils/request-handler.js';

export default class RelatedProducts {
    constructor() {
        this.identifier = 'data-related-products';
        this.selector = '[' + this.identifier + ']';
        this.responseHandler = new ResponseHandler;
        this.requestHandler = new RequestHandler;
    }

    setup() {
        const divs = document.querySelectorAll(this.selector);
        divs.forEach(function(el) {
            let query = JSON.parse(el.getAttribute(this.identifier));
            if (!query) {
                return;
            }
            this.requestHandler.get(
                constants.BASEPATH + '/ajax/related-products.json', query, this.dataCallback.bind(this)
            );
        }.bind(this));
    }

    dataCallback(response) {
        if (this.responseHandler.isSuccess(response)) {
            let data = this.responseHandler.getData(response);
            let params = {
                parentId: data.parentId,
                relatedDeals: JSON.stringify(data.relatedDeals)
            };
            this.requestHandler.get(
                constants.CHECKOUTPATH + '/item-upsell', params, this.htmlCallback.bind(this)
            );
        } else {
            console.error(this.responseHandler.getErrors(response), 'RelatedProducts data callback error');
        }
    }

    htmlCallback(response) {
        if (this.responseHandler.isSuccess(response)) {
            let data = this.responseHandler.getData(response);
            const divs = document.querySelectorAll(this.selector);
            divs.forEach(function(el) {
                let query = JSON.parse(el.getAttribute(this.identifier));
                if (!query || (query.parentId !== data.parentId)) {
                    return;
                }
                el.innerHTML = data.html;
            }.bind(this));
        } else {
            console.error(this.responseHandler.getErrors(response), 'RelatedProducts html callback error');
        }
    }
}
